import Icon from '../components/Icon.vue'

Icon.register({
  'id-card-alt': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M528 64c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-480c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h144v96h192v-96h144zM288 224c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zM381.3 448c10.4 0 18.8-10 15.6-19.8-8.4-25.7-32.5-44.2-60.9-44.2h-8.2c-12.2 5.1-25.7 8-39.8 8s-27.5-2.9-39.8-8h-8.2c-28.5 0-52.6 18.6-60.9 44.2-3.2 9.8 5.2 19.8 15.6 19.8h186.6zM352 32v96h-128v-96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/id-card-alt.js
// module id = 1479
// module chunks = 0